import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'

import { BaseDialog, FileUploadInput, LoadingFeedback } from 'components'

import * as service from 'service'
import useSnackbar from 'hooks/useSnackbar'
import schema from './schema'
import useStyles from './styles'
import constants from 'constants/index'
import { FormContext, useForm } from 'react-hook-form'

const ImportEmailsDialog = ({ open, setOpen, token }) => {
  const classes = useStyles()
  const snackbar = useSnackbar()

  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: {
      fileToImport: undefined,
    },
  })

  const { handleSubmit } = formMethods

  const [loading, setLoading] = useState(false)

  const handleClose = () => {
    if (loading) return
    setOpen(false)
  }

  const onSubmit = async (data) => {
    setLoading(true)

    try {
      await service.dponet.consent.importEmails({
        ...data,
        token,
      })

      snackbar.open({
        message:
          'Arquivo enviado com sucesso! Você será notificado via e-mail.',
        variant: 'success',
      })

      handleClose()
    } catch (error) {
      const errorMessage = error?.response?.data?.error?.message

      snackbar.open({
        message: errorMessage,
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={handleClose}
      title="Importar E-mails"
      closeButtonText="Cancelar"
      actionButtonText="Enviar e-mails"
      formRef="import-emails-dialog"
    >
      <form id="import-emails-dialog" onSubmit={handleSubmit(onSubmit)}>
        <FormContext {...formMethods}>
          <LoadingFeedback open={loading} />
          <Box className={classes.box}>
            <Typography align="justify" className={classes.typography}>
              Selecione um arquivo (CSV ou XLSX) contendo os e-mails. O arquivo
              deve ter uma coluna chamada <strong>"E-mail"</strong>.
            </Typography>
            <FileUploadInput
              controlName="fileToImport"
              accept={constants.consent.FILE_IMPORT_TYPE}
              hasDownloadFile
            />
          </Box>
        </FormContext>
      </form>
    </BaseDialog>
  )
}

ImportEmailsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
}

export default ImportEmailsDialog
